module.exports = __webpack_public_path__ + "img/Dantam Makeover 19.0dc829b6.jpg";